import { getImgSources, getImgSrcSet } from "@ui/utils/image";
import { cx } from "@uxf/core/utils/cx";
import { resizerImageUrl } from "@uxf/core/utils/resizer";
import React, { AriaAttributes, ImgHTMLAttributes, memo } from "react";

type ImgProps = ImgHTMLAttributes<HTMLImageElement>;

interface FileResponse {
    extension: string;
    namespace?: string | null;
    uuid: string;
}

interface Props extends AriaAttributes {
    alt: string;
    className?: string;
    height: number | "auto";
    imgClassName?: string;
    loading?: ImgProps["loading"];
    mode?: "contain" | "cover" | "responsive";
    role?: ImgProps["role"];
    src?: FileResponse | null;
    width: number | "auto";
}

export const RasterImage = memo<Props>(
    ({ alt, className, height, imgClassName, loading = "lazy", mode = "responsive", src, width, ...restProps }) => {
        const Element = src ? "picture" : "div";
        return (
            <Element className={`_raster-image ${className || ""}`}>
                {src ? (
                    <>
                        {getImgSources(src, width, height)}
                        <img
                            alt={alt}
                            className={cx(
                                "_raster-image__img",
                                mode === "contain" && "_raster-image__img--contain",
                                mode === "cover" && "_raster-image__img--cover",
                                imgClassName,
                            )}
                            loading={loading}
                            height={height !== "auto" ? height : undefined}
                            src={resizerImageUrl(src, width, height, {}) ?? undefined}
                            srcSet={getImgSrcSet(src, width, height) ?? undefined}
                            width={width !== "auto" ? width : undefined}
                            {...restProps}
                        />
                    </>
                ) : null}
            </Element>
        );
    },
);

RasterImage.displayName = "RasterImage";
